import { useShow } from '@refinedev/core'
import { Show } from '@refinedev/mui'
import { Alert, Box, Chip, Divider, Stack, Typography } from '@mui/material'

export const RelationalIntroductionLetterDraftsShow = () => {
  const { query } = useShow({
    resource: 'relational-introduction-letter-drafts',
  })
  const { data, isLoading } = query
  const record = data?.data

  return (
    <Show isLoading={isLoading}>
      <Stack spacing={2}>
        <Typography variant="h5">Relational Introduction Letter Drafts</Typography>
        {record?.versions?.map((version: any) => (
          <Box
            key={version.id}
            sx={{ border: '1px solid #ddd', borderRadius: 2, p: 2 }}
          >
            <Stack direction="row" spacing={1} alignItems="center" mb={1}>
              <Chip label={`v${version.version_number}`} size="small" />
              <Chip label={version.source} size="small" variant="outlined" />
              <Typography variant="caption">{version.created_at}</Typography>
            </Stack>
            {version.regeneration_feedback ? (
              <Alert severity="info" sx={{ mb: 1 }}>
                {version.regeneration_feedback}
              </Alert>
            ) : null}
            <Typography sx={{ whiteSpace: 'pre-wrap' }}>{version.content}</Typography>
            <Divider sx={{ mt: 2 }} />
          </Box>
        ))}
      </Stack>
    </Show>
  )
}
